import { Row, Typography } from "@commonlibs";
import styled, { css } from "styled-components";

export const TableActionsRoot = styled(Row)<{ hasTitle: boolean }>(
    ({ theme, hasTitle }) => css`
        display: grid;
        grid-template-columns: ${hasTitle ? "auto 1fr" : "1fr"};
        gap: 10px;
        align-items: center;
        ${theme.breakpoints.down("mobile")} {
            .search-bar {
                width: 100%;
            }
        }
    `,
);

export const TableName = styled(Typography)(
    () => css`
        white-space: nowrap; /* evita que el texto salte de línea */
        overflow: hidden; /* oculta el texto que se desborda */
        text-overflow: ellipsis; /* muestra los puntos suspensivos */
        display: block;
    `,
);

export const TableToolbar = styled(Row)<{ hasTitle: boolean }>(
    ({ hasTitle }) => css`
        justify-content: ${hasTitle ? "end" : "space-between"};
    `,
);
